import { render, staticRenderFns } from "./TicketDetailsRow.vue?vue&type=template&id=60831202"
import script from "./TicketDetailsRow.vue?vue&type=script&lang=js"
export * from "./TicketDetailsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports